export default "__VITE_ASSET__DXqbdgg___"